import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { DefaultAvatar } from 'atoms/default-avatar';
import Dropdown from 'atoms/dropdown';
import { isNotEmptyArray } from 'util';

import { groomerToOption } from '.';

function CustomAvatarContent({ groomer }) {
  return (
    <DefaultAvatar
      size="small"
      avatar={groomer?.links?.image?.desktop?.small}
      className="mr-10"
    />
  );
}

export default function GroomerSelect({
  animalType,
  selectedGroomer,
  setSelectedGroomer,
}) {
  const { groomers } = useSelector((state) => state.groomers);
  const groomersDropdownOptions = groomers
    .filter((groomer) =>
      groomer.animal?.type?.find((type) => type.id === animalType)
    )
    .map(({ user }) => groomerToOption(user));

  useEffect(() => {
    if (
      !groomersDropdownOptions.find(
        (groomer) => groomer.uuid === selectedGroomer.uuid
      )
    ) {
      if (isNotEmptyArray(groomersDropdownOptions))
        return setSelectedGroomer(groomersDropdownOptions[0]);
      return setSelectedGroomer({});
    }
  }, [animalType]);

  const onSelectGroomer = (groomer) => {
    if (groomer) setSelectedGroomer(groomer);
  };

  if (!isNotEmptyArray(groomers))
    return <h3 className="f16 mb-15">No groomers available</h3>;

  return (
    <Dropdown
      className="groomer-select-dropdown"
      variant="white"
      size="extra-small"
      shape="round"
      items={groomersDropdownOptions}
      value={selectedGroomer?.name}
      CustomContent={() => CustomAvatarContent({ groomer: selectedGroomer })}
      onClick={onSelectGroomer}
    />
  );
}
